import { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Table from "react-bootstrap/Table";
import { ShowPDF } from "./CommonUtilities/CommonFunctions/CommonFunction";
import { downloadPDF } from "./CommonUtilities/CommonFileUpload/ViewImage";
import { BsDownload, BsEye } from "react-icons/bs";
import Spinner from "react-bootstrap/Spinner";
import { config } from "./CommonUtilities/CommonUrl/CommonUrls";

export const documentData = {
  pressNote: [
    {
      name: "MEGA DSC _ Press Note - EM",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105508922_.pdf",
    },
    {
      name: "MEGA DSC _ Press Note - TM",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105545966_.pdf",
    },
    {
      name: "Press Note Final",
      url: "/DSC-PDF/Press-2025/Press Note Final 11.7.25.pdf",
    },
    {
      name: "Fake News in Social Media - Clarifications to Candidates",
      url: "/DSC-PDF/Press-2025/Fake News.pdf",
    },
    {
      name: "DSC Press Note (21-8-2025)",
      url: "/DSC-PDF/Press-2025/PRESS RELEASE (21-8-2025).pdf",
    },
    {
      name: "DSC Press Note (22.8.2025) on Merit List",
      url: "/DSC-PDF/Press-2025/DSC_Press Note 22.8.2025.pdf",
    },
    {
      name: "Final Press Release 25.8.2025-1",
      url: "/DSC-PDF/Press-2025/Final Press Release 25.8.2025-1.pdf",
    },
    {
      name: "MEGA DSC-2025 List of Doc for verificationa and Qualificaions",
      url: "/DSC-PDF/Press-2025/MEGA DSC-2025 List of Doc for verificationa and Qualificaions.pdf",
    },
    {
      name: "DSC Press Note 29.8.2025",
      url: "/DSC-PDF/Press-2025/Press Note.pdf",
    },
  ],
  gos: [
    {
      name: "G.O.Ms.77, GAD (Ser.D), Dt:02.08.2023.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105141099_.pdf",
    },
    {
      name: "G.O.Ms.No:03, GAD(Ser.D), Dt:17.01.2024.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105069018_.pdf",
    },
    {
      name: "G.O.Rt.No:56, School Education (Services-1) Dept., Dated:09.02.2024.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105319843_.pdf",
    },
    {
      name: "G.O.Ms.No:11, School Education (Services-1) Dept., Dated:12.02.2024",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105286764_.pdf",
    },
    {
      name: "G.O.Ms.No:12, School Education (Services-1) Dept., Dated:12.02.2024",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105296858_.pdf",
    },
    {
      name: "G.O.Ms.No:27, School Education (Services-1) Dept., Dated:13.06.2024.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105180295_.pdf",
    },
    {
      name: "G.O.Rt.No:256, School Education (Services-1) Dept., Dated:30.06.2024.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105326237_.pdf",
    },
    {
      name: "G.O.Ms.No:14, School Education (Services-1) Dept., Dated:15.04.2025.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745104748073_.pdf",
    },
    {
      name: "G.O.Ms.No:12, School Education (Services-1) Dept., Dated:17.04.2025.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105169054_.pdf",
    },
    {
      name: "G.O.Ms.No.4, Youth, Advancement, Tourism and Culture (Sports), Dated:19.04.2025.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105215758_.pdf",
    },
    {
      name: "G.O.Ms.No.7, Social Welfare (CV) Department , dt: 18-04-20205",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105247931_.pdf",
    },
    {
      name: "G.O.Ms.No:46, GAD(Ser.D), Dt:19.04.2025.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105090281_.pdf",
    },
    {
      name: "G.O.Ms.No:47, GAD(Ser.D), Dt:19.04.2025.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105117199_.pdf",
    },
    {
      name: "G.O.Ms.No:15, School Education (Services-1) Dept., Dt:19.04.2025.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105305015_.pdf",
    },
    {
      name: "G.O.Ms.No:16, School Education (Services-1) Dept., Dt:19.04.2025.",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105313425_.pdf",
    },
    {
      name: "NORMALIZATION",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105418986_.pdf",
    },
    {
      name: "ORDINANCE- SC CLASSIFICATION (1)	",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105445190_.pdf",
    },
    {
      name: "G O Ms No 17",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745928353836_.pdf",
    },
    {
      name: "G O Ms No 18",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745928437416_.pdf",
    },
    {
      name: "Amendment School Education",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745934981992_.pdf",
    },
    {
      name: "Amendment Societies",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745928724920_.pdf",
    },
  ],
  syllabus: [
    {
      name: "MEGA DSC_2025_Suggestive_Syllabus",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105618794_.pdf",
    },
  ],
  schedule: [
    {
      name: "AP MEGA DSC schedule",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745105586939_.pdf",
    },
  ],
  faqs: [
    {
      name: "MEGA DSC FAQ EM",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745104589077_.pdf",
    },
    {
      name: "MEGA DSC FAQsTM",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745104669923_.pdf",
    },
  ],
  manuals: [
    {
      name: "User Manual Document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745112162841_.pdf",
      type: "document",
    },
    {
      name: "User Manual Video (English)",
      url: "https://youtu.be/JQ92XJwpZQ8",
      type: "video",
    },
    {
      name: "User Manual Video (Telugu)",
      url: "https://youtu.be/eyXIaNtOI6o",
      type: "video",
    },
  ],
  school: [
    // { name: "School Education Notification", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745200345488_.pdf", },
    {
      name: "School Education Notification",
      url: "/DSC-PDF/Notifications/School Edu Notification.pdf",
    },
    {
      name: "School Education Bulletin",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745200455385_.pdf",
    },
  ],
  society: [
    // { name: "Residential Schools Notification", url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745200548788_.pdf", },
    {
      name: "Residential Schools Notification",
      url: "/DSC-PDF/Notifications/Socities Notification.pdf",
    },
    {
      name: "Residential Schools Bulletin",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1745200590856_.pdf",
    },
  ],
  MockTest: [
    {
      name: "SGT",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M128",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Principal",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M129",
      type: "video",
      post: "Mock",
    },
    {
      name: "TGT Social",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M130",
      type: "video",
      post: "Mock",
    },
    {
      name: "TGT Physical science",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M131",
      type: "video",
      post: "Mock",
    },
    {
      name: "TGT Maths",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M132",
      type: "video",
      post: "Mock",
    },
    {
      name: "TGT Biological science",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M133",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Biological science",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M134",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Botany",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M135",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Commerce",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M136",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Economics",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M137",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT English",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M138",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Maths",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M139",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Physical science",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M140",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Social",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M141",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Telugu",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M142",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Zoology",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M143",
      type: "video",
      post: "Mock",
    },
    {
      name: "TGT Proficiency Test",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M144",
      type: "video",
      post: "Mock",
    },
    {
      name: "Proficiency Test Principle",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M145",
      type: "video",
      post: "Mock",
    },
    {
      name: "Principle",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M146",
      type: "video",
      post: "Mock",
    },
    {
      name: "Proficiency Test PGT",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M147",
      type: "video",
      post: "Mock",
    },
    {
      name: "TGT English",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M148",
      type: "video",
      post: "Mock",
    },
    {
      name: "TGT Hindi",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M149",
      type: "video",
      post: "Mock",
    },
    {
      name: "TGT Sanskrit",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M150",
      type: "video",
      post: "Mock",
    },
    {
      name: "TGT Telugu",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M151",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Tamil",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M152",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Odiya",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M153",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Kannada",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M154",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Urdu",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M155",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Social",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M156",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Biological Science",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M157",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Physical Science",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M158",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Maths",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M159",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Sanskrit",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M160",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Hindi",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M161",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA English",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M162",
      type: "video",
      post: "Mock",
    },
    {
      name: "SA Telugu",
      url: "https://g21.digialm.com//OnlineAssessment/index.html?1950@@M163",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Hindi",
      url: "https://g21.digialm.com/OnlineAssessment/index.html?1950@@M164",
      type: "video",
      post: "Mock",
    },
    {
      name: "PGT Sanskrit",
      url: "https://g21.digialm.com/OnlineAssessment/index.html?1950@@M165",
      type: "video",
      post: "Mock",
    },
    {
      name: "PET PE PD",
      url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M166",
      type: "video",
      post: "Mock",
    },
  ],

  //----------------TET MockTest Links ----------------//
  TetMockTest: [
    {
      name: "PAPER_IA_SGT",
      url: "https://cdn3.digialm.com//OnlineAssessment/index.html?1950@@M107",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER_IIB",
      url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M122",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER_IB",
      url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M99",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER_IIA_LAN_TELUGU",
      url: "	https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M104",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER_IIA_LAN_URDU",
      url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M105",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER IIA LAN HINDI",
      url: "https://cdn3.digialm.com//OnlineAssessment/index.html?1950@@M126",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER_IIA_LAN_KM",
      url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M101",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER_IIA_LAN_OM",
      url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M102",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER_IIA_LAN_TAM",
      url: "	https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M103",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER_IIA_LAN_ENG",
      url: "https://g21.tcsion.com//OnlineAssessment/index.html?1950@@M168",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER IIA LAN SANSKRIT",
      url: "https://cdn3.digialm.com//OnlineAssessment/index.html?1950@@M127",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER_IIA_MATHS",
      url: "https://cdn3.digialm.com//OnlineAssessment/index.html?1950@@M167",
      type: "video",
      post: "Mock",
    },
    {
      name: "PAPER_IIA_SOCIAL",
      url: "https://g21.digialm.com:443//OnlineAssessment/index.html?1950@@M108",
      type: "video",
      post: "Mock",
    },
  ],
  spl_tet_aug_go: [
    {
      name: "Special TET Govt Memo",
      url: process.env.PUBLIC_URL + "/SplTetAug2026/GOS/SPL TET Govt Memo.pdf",
    },
    {
      name: "Permission To Conduct Special TET",
      url: process.env.PUBLIC_URL + "/SplTetAug2026/GOS/Govt permission memo Special TET.pdf",
    },
  ],
  spl_tet_notification: [
    {
      name: "Special TET Notification -2026",
      url: process.env.PUBLIC_URL + "/SplTetAug2026/Spl TET Notification final.pdf",
    },
  ],
  spl_tet_bulletien: [
    {
      name: "Special TET information Bulletien-2026",
      url: process.env.PUBLIC_URL + "/SplTetAug2026/Spl TET information bulletin.pdf",
    },
  ],
  spl_tet_schedule: [
    {
      name: "Special TET Tentative Schedule",
      url: process.env.PUBLIC_URL + "/SplTetAug2026/Spl TET Schedule.pdf",
    },
    {
      name: "Special TET Exam Schedule",
      url: process.env.PUBLIC_URL + "/SplTetAug2026/AP SPL TET FOR INSERVICE TEACHERS-2026_EXAM SCHEDULE.pdf",
    },
  ],
  spl_tet_press_note: [
    {
      name: "Special TET Press Note",
      url: process.env.PUBLIC_URL + "/SplTetAug2026/AP SPL TET PRESS NOTE.pdf",
    },
  ],
  spl_tet_faqs: [
    {
      name: "Special TET FAQ's",
      url: process.env.PUBLIC_URL + "/SplTetAug2026/In-service TET FAQs Approved Copy.pdf",
    },
  ],

  // FinalKey: showExamKeys
  tet_go: [
    {
      name: "GO.2025SE_MS36_E",
      url: process.env.PUBLIC_URL + "/TET-PDF/GOS/GO 36 TET1 2026.pdf",
    },
  ],
  tet_2025_prss_note: [
    {
      name: "APTET Press Note",
      url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/Press note on APTET.pdf",
    },
  ],
  tet_press_note: [
    {
      name: "APTET Press Note G.O 36",
      url:
        process.env.PUBLIC_URL +
        "/TET-PDF/PressNote/APTET- JUNE 2026 PRSS NOTE -1.pdf",
    },
    {
      name: "APTET Press Note -2026",
      url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/Latest PressNote.pdf",
    },
  ],
  tet_2025_notification: [
    {
      name: "APTET Notification -2025",
      url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/APTET Notification -2025 final.pdf",
    },
  ],
  tet_notification: [
    {
      name: "APTET Notification -2026",
      url: process.env.PUBLIC_URL + "/TET-PDF/APTET-2026 Notification.pdf",
    },
  ],
  // tet_latestpressnote: [{ name: "APTET Press Note -2025", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/TETPressNote.pdf" },],
  tet_2025_schedule: [
    {
      name: "APTET Tentative Schedule",
      url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/APTET TENTATIVE SCHEDULE.pdf",
    },
  ],
  tet_schedule: [
    {
      name: "APTET Tentative Schedule",
      url:
        process.env.PUBLIC_URL +
        "/TET-PDF/APTET- JUNE 2026 TENTATIVE SCHEDULE.pdf",
    },
    { name: "APTET EXAM SCHEDULE", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/AP TET-2026_EXAM SCHEDULE.pdf" },
  ],
  tet_2025_syllabus: [
    {
      name: "APTET 2025 Syllabus",
      url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/TET  OCTOBER 2025 SYLLABUS BOOK FINAL.pdf",
    }
  ],
  tet_syllabus: [
    {
      name: "Special Education DSC - 2026",
      url:
        process.env.PUBLIC_URL +
        "/DSC-PDF/Syllabus-2026/Special Education DSC - 2026.pdf",
    },
    {
      name: "APTET 2026 Syllabus",
      url: process.env.PUBLIC_URL + "/TET-PDF/APTET 2026 Syllabus 1.pdf",
    },
    // { name: "APTET 2025 Syllabus", url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/APTET 2025 Syllabus.pdf" },
  ],
  tet_2025_bullitin: [
    {
      name: "APTET information Bulletien-2025",
      url: process.env.PUBLIC_URL + "/TET-PDF/PressNote/APTET information Bulletien-2025 final.pdf",
    },
  ],
  tet_bullitin: [
    {
      name: "APTET information Bulletien-2026",
      url: process.env.PUBLIC_URL + "/TET-PDF/APTET Information Bulliten.pdf",
    },
  ],

  tet_manuals: [
    {
      name: "User Manual Document",
      url: process.env.PUBLIC_URL + "/TET-PDF/UserManual/User Manual.pdf",
      type: "document",
    },
    {
      name: "User Manual Video (English)",
      url: "https://youtu.be/DZbRLOzkeJg",
      type: "video",
    },
  ],
  guide_lines: [
    {
      name: "APTET-2026 Guidelines",
      url:
        process.env.PUBLIC_URL + "/TET-PDF/UserManual/APTET-2026 Guidlines.pdf",
      type: "document",
    },
  ],
  tet_2025_faq: [
    {
      name: "APTET 2025 FAQS",
      url: process.env.PUBLIC_URL + "/TET-PDF/APTET 2025 FAQS.pdf",
    },
  ],
  tet_faq: [
    {
      name: "APTET 2026 FAQS",
      url: process.env.PUBLIC_URL + "/TET-PDF/APTET 2026 FAQS.pdf",
    },
    {
      name: "APTET FAQS FOR INSERVICE TEACHERS",
      url: process.env.PUBLIC_URL + "/TET-PDF/FAQ Inservice.pdf",
    },
  ],
  // tet_hallticket: [{ name: "APTET Hall Tickets Released",}],
  // tet_score: { name: "Final Key", clickable: () => { handleCShow(); }},

  tet_answerkey: [
    {
      name: (
        <>
          {" "}
          <img
            src="/img/new2.gif"
            style={{ height: "30px" }}
            className="img-fluid"
            alt="new"
          />
          <span className="text-danger">
            {" "}
            APTET Final Answer Keys Released{" "}
          </span>
        </>
      ),
      url: "data",
    },
  ],
  // tet_final_key: { name: "Final Key", clickable: () => { handleGoClose(); renderExams(); }}
  tet_final_key: { name: "Final Key", url: "renderExams" },

  tet_2026_keys: [
    {
      name: "SGT IA TELUGU 10th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150407486_SGTIATELUGU10thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789225211425_SGTIATELUGU10thAug2026Shift1SetB.pdf"
      //final_url: "DSC_PUBLIC_UPLOADS/1789217807368_SGTIATELUGU10thAug2026Shift2SetB.pdf"//doubt
    },
    {
      name: "SGT IA URDU 09th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150407622_SGTIAURDU09thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217797386_SGTIAURDU09thAug2026Shift2SetC.pdf"
    },
    {
      name: "SGT 1A TELUGU 07th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593403_SGT1ATELUGU07thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217811440_SGT1ATELUGU07thAug2026Shift2setc.pdf"
    },
    {
      name: "SGT IA HINDI 09th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150588979_SGTIAHINDI06thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789229992713_SGTIAHINDI09thAug2026Shift2SetC.pdf"
      //"DSC_PUBLIC_UPLOADS/1789217790062_SGTIAHINDI09thAug2026Shift2SetC.pdf"
    },
    {
      name: "SGT IA KANNADA 09th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150592839_SGTIAKANNADA09thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217808085_SGTIAKANNADA09thAug2026Shift2SetC.pdf"
    },
    {
      name: "SGT IA ODIYA 09th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150592948_SGTIAODIYA09thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217808808_SGTIAODIYA09thAug2026Shift2SetC.pdf"
    },
    {
      name: "SGT IA TAMIL 09th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593570_SGTIATAMIL09thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217811851_SGTIATAMIL09thAug2026Shift2SetC.pdf"
    },
    {
      name: "SGT IA TELUGU 06th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150592756_SGTIATELUGU06thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217803421_SGTIATELUGU06thAug2026Shift2SetB.pdf"
    },
    {
      name: "SGT IA TELUGU 07th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593577_SGTIATELUGU07thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217799091_SGTIATELUGU07thAug2026Shift1SetC.pdf"
    },
    {
      name: "SGT IA TELUGU 08th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593404_SGTIATELUGU08thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217811074_SGTIATELUGU08thAug2026Shift1SetB.pdf"
    },
    {
      name: "SGT IA TELUGU 08th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150592528_SGTIATELUGU08thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217802567_SGTIATELUGU08thAug2026Shift2SetC.pdf"
    },
    {
      name: "SGT IA TELUGU 09th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593175_SGTIATELUGU09thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217810585_SGTIATELUGU09thAug2026Shift1SetB.pdf"
    },
    {
      name: "SGT IA TELUGU 09th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593570_SGTIATELUGU09thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217811920_SGTIATELUGU09thAug2026Shift2SetC.pdf"
    },
    {
      name: "PAPER IIA LAN URDU 06th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150583435_PAPERIIALANURDU06thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217763622_PAPERIIALANURDU06thAug2026Shift1SetB.pdf"
    },
    {
      name: "PAPER IIA MS TELUGU 12th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593122_PAPERIIAMSTELUGU12thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217810439_PAPERIIAMSTELUGU12thAug2026Shift2.pdf"
    },
    {
      name: "PAPER IIA MS TELUGU 13th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593796_PAPERIIAMSTELUGU13thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217812173_PAPERIIAMSTELUGU13thAug2026Shift1.pdf"
    },
    {
      name: "PAPER IIA MS TELUGU 14th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150592685_PAPERIIAMSTELUGU14thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217807487_PAPERIIAMSTELUGU14thAug2026Shift2.pdf"
    },
    {
      name: "PAPER IIA SS HINDI 10th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593811_PAPERIIASSHINDI10thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217808140_PAPERIIASSHINDI10thAug2026Shift2SetC.pdf"
    },
    {
      name: "PAPER IIA SS KANNADA 10th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150592707_PAPERIIASSKANNADA10thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217806717_PAPERIIASSKANNADA10thAug2026Shift2SetC.pdf"
    },
    {
      name: "PAPER IIA SS ORIYA 10th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593495_PAPERIIASSORIYA10thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217811569_PAPERIIASSORIYA10thAug2026Shift2SetC.pdf"
    },
    {
      name: "PAPER IIA SS SANSKRIT 10th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593299_PAPERIIASSSANSKRIT10thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217811156_PAPERIIASSSANSKRIT10thAug2026Shift2SetC.pdf"
    },
    {
      name: "PAPER IIA SS TAMIL 10th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593802_PAPERIIASSTAMIL10thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217806728_PAPERIIASSTAMIL10thAug2026Shift2SetC.pdf"
    },
    {
      name: "PAPER IIA SS TELUGU 10th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593796_PAPERIIASSTELUGU10thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217812041_PAPERIIASSTELUGU10thAug2026Shift2SetC.pdf"
    },
    {
      name: "PAPER IIA SS TELUGU 11th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593163_PAPERIIASSTELUGU11thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217809909_PAPERIIASSTELUGU11thAug2026Shift1SetB.pdf"
    },
    {
      name: "PAPER IIA SS URDU 10th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150591271_PAPERIIASSURDU10thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217799200_PAPERIIASSURDU10thAug2026Shift2SetC.pdf"
    },
    {
      name: "PAPER IB Spl Edu Tamil 10th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593181_PAPERIBSplEduTamil10thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217809998_PAPERIBSplEduTamil10thAug2026Shift1SetB.pdf"
    },
    {
      name: "PAPER IB Spl Edu Urdu 10th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150589750_PAPERIBSplEduUrdu10thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217792908_PAPERIBSplEduUrdu10thAug2026Shift1SetB.pdf"
    },
    {
      name: "PAPER II A SS TELUGU 11th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593225_PAPERIIASSTELUGU11thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217810489_PAPERIIASSTELUGU11thAug2026Shift2.pdf"
    },
    {
      name: "PAPER II B SA SPL EDU HINDI 12th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150590496_PAPERIIBSASPLEDUHINDI12thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217796518_PAPERIIBSASPLEDUHINDI12thAug2026Shift2.pdf"
    },
    {
      name: "PAPER II B SA SPL EDU ORIYA 12th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150592327_PAPERIIBSASPLEDUORIYA12thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217804683_PAPERIIBSASPLEDUORIYA12thAug2026Shift2.pdf"
    },
    {
      name: "PAPER II B SA SPL EDU SANSKRIT 12th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593820_PAPERIIBSASPLEDUSANSKRIT12thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217812395_PAPERIIBSASPLEDUSANSKRIT12thAug2026Shift2.pdf"
    },
    {
      name: "PAPER II B SA SPL EDU TAMIL 12th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593795_PAPERIIBSASPLEDUTAMIL12thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217807649_PAPERIIBSASPLEDUTAMIL12thAug2026Shift2.pdf"
    },
    {
      name: "PAPER II B SA SPL EDU TELUGU 12th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593971_PAPERIIBSASPLEDUTELUGU12thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217808816_PAPERIIBSASPLEDUTELUGU12thAug2026Shift2.pdf"
    },
    {
      name: "PAPER II B SA SPL EDU URDU 12th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150589828_PAPERIIBSASPLEDUURDU12thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217794268_PAPERIIBSASPLEDUURDU12thAug2026Shift2.pdf"
    },
    {
      name: "Paper IIA LAN ENGLISH 16th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150594773_PaperIIALANENGLISH16thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217811336_PaperIIALANENGLISH16thAug2026Shift2.pdf"
    },
    {
      name: "PAPER IIA LAN KANNADA 06th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150587242_PAPERIIALANKANNADA06thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217782140_PAPERIIALANKANNADA06thAug2026Shift1SetB.pdf"
    },
    {
      name: "PAPER IIA LAN ORIYA 06th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150589862_PAPERIIALANORIYA06thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217793383_PAPERIIALANORIYA06thAug2026Shift1SetB.pdf"
    },
    {
      name: "PAPER IIA LAN TELUGU 05th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150589407_PAPERIIALANTELUGU05thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217791272_PAPERIIALANTELUGU05thAug2026Shift1SetB.pdf"
    },
    {
      name: "PAPER IIA LAN TELUGU 05th Aug 2026 Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150592425_PAPERIIALANTELUGU05thAug2026Shift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217802171_PAPERIIALANTELUGU05thAug2026Shift2.pdf"
    },
    {
      name: "PAPER IIA LAN TELUGU URDU 06th Aug 2026 Shift1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150588960_PAPERIIALANTELUGUURDU06thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217789448_PAPERIIALANTELUGUURDU06thAug2026Shift1SetB.pdf"
    },
    {
      name: "IIA HINDI URDU 12th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150588614_IIAHINDIURDU12thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217788300_IIAHINDIURDU12thS1SetA.pdf"
    },
    {
      name: "IIA LAN SANSKRIT 06th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150590877_IIALANSANSKRIT06thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217797047_IIALANSANSKRIT06thAug2026Shift1SetB.pdf"
    },
    {
      name: "IIA LAN SANSKRIT TELUGU 06th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150590777_IIALANSANSKRITTELUGU06thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217797056_IIALANSANSKRITTELUGU06thAug2026Shift1SetB.pdf"
    },
    {
      name: "IIA LAN TAMIL 06th Aug Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150591447_IIALANTAMIL06thAugShift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217800018_IIALANTAMIL06thAugShift1SetB.pdf"
    },
    {
      name: "IIA LAN TELUGU 06th Aug 2026 shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150590395_IIALANTELUGU06thAug2026shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217795763_IIALANTELUGU06thAug2026shift1SetB.pdf"
    },
    {
      name: "IIA LAN TELUGU SANSKRIT 06th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150590466_IIALANTELUGUSANSKRIT06thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217795954_IIALANTELUGUSANSKRIT06thAug2026Shift1SetB.pdf"
    },
    {
      name: "IIA LAN URDU KANNADA 06th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150584249_IIALANURDUKANNADA06thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217767939_IIALANURDUKANNADA06thAug2026SetB.pdf"
    },
    {
      name: "IIA LAN URDU TELUGU 06th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150585047_IIALANURDUTELUGU06thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217771261_IIALANURDUTELUGU06thAug2026SetB.pdf"
    },
    {
      name: "IIA MS 13th Shift 2",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150592237_IIAMS13thShift2.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217803915_IIAMS13thShift2SetB.pdf"
    },
    {
      name: "IIA MS 14th Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593275_IIAMS14thShift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217811368_IIAMS14thShift1SetB.pdf"
    },
    {
      name: "IIA MS 16th Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593939_IIAMS16thShift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217812581_IIAMS16thShift1SetC.pdf"
    },
    {
      name: "IIA MS Hindi 16th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150591350_IIAMSHindi16thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217799990_IIAMSHindi16thS1SetC.pdf"
    },
    {
      name: "IIA MS Kannada 16th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593299_IIAMSKannada16thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217811399_IIAMSKannada16thS1SetC.pdf"
    },
    {
      name: "IIA MS Oriya 16th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593180_IIAMSOriya16thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217810555_IIAMSOriya16thS1SetC.pdf"
    },
    {
      name: "IIA MS Sanskrit 16th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593811_IIAMSSanskrit16thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217812570_IIAMSSanskrit16thS1SetC.pdf"
    },
    {
      name: "IIA MS Tamil 16th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150593570_IIAMSTamil16thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217811885_IIAMSTamil16thS1SetC.pdf"
    },
    {
      name: "IIA MS Urdu 16th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150589493_IIAMSUrdu16thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217792851_IIAMSUrdu16thS1SetC.pdf"
    },
    {
      name: "IIA TELUGU HINDI 06th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150589582_IIATELUGUHINDI06thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217792407_IIATELUGUHINDI06thAug2026Shift1SetB.pdf"
    },
    {
      name: "PAPER IB Spl Edu 10th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150589484_PAPERIBSplEdu10thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217792116_PAPERIBSplEdu10thAug2026Shift1SetB.pdf"
    },
    {
      name: "PAPER IB Spl Edu Hindi 10th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150588176_PAPERIBSplEduHindi10thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217786392_PAPERIBSplEduHindi10thAug2026Shift1SetB.pdf"
    },
    {
      name: "PAPER IB Spl Edu Kannada 10th Aug 2026 Shift 1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150592589_PAPERIBSplEduKannada10thAug2026Shift1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217805518_PAPERIBSplEduKannada10thAug2026Shift1SetB.pdf"
    },
    {
      name: "IIA HINDI 12th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150589232_IIAHINDI12thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217790566_IIAHINDI12thS1SetA.pdf"
    },
    {
      name: "IIA HINDI KANNADA 12th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150589432_IIAHINDIKANNADA12thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217791762_IIAHINDIKANNADA12thS1SetA.pdf"
    },
    {
      name: "IIA HINDI ORIYA 12th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150589157_IIAHINDIORIYA12thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217790566_IIAHINDIORIYA12thS1SetA.pdf"
    },
    {
      name: "IIA HINDI TELUGU 12th S1",
      type: "document",
      url: config.url.FILE_VIEW_URL + "DSC_PUBLIC_UPLOADS/1787150590291_IIAHINDITELUGU12thS1.pdf",
      final_url: "DSC_PUBLIC_UPLOADS/1789217795413_IIAHINDITELUGU12thS1SetA.pdf"
    }
  ],
  dsc_2026_syllabus: [
    { name: "DSC 2026 Syllabus", url: process.env.PUBLIC_URL + "/DSC2026/DSC_2026 Suggestive Syllabus.pdf" },
  ],
  dsc_2026_gos: [
    { name: "G.O.MS.No. 28", url: process.env.PUBLIC_URL + "/DSC2026/Gos/2026SE_MS28_E.pdf" },
    { name: "G.O.MS.No. 29", url: process.env.PUBLIC_URL + "/DSC2026/Gos/2026SE_MS29_E.pdf" },
    { name: "G.O.MS.No. 30", url: process.env.PUBLIC_URL + "/DSC2026/Gos/2026SE_MS30_E.pdf" },
  ],
  dsc_2026_notifications: [
    { name: "General Notification", url: process.env.PUBLIC_URL + "/DSC2026/notifications/DSC-2026 General notification (1).pdf" },
    { name: "Socities Notification", url: process.env.PUBLIC_URL + "/DSC2026/notifications/DSC-2026 Socities Notification.pdf" },
    { name: "Special Education Notifcation", url: process.env.PUBLIC_URL + "/DSC2026/notifications/DSC-2026 Special Education Notifcation.pdf" },
  ],
  dsc_2026_press_note: [
    { name: "Press Note", url: process.env.PUBLIC_URL + "/DSC2026/DSC-2026 Press Note English.pdf" },
  ],
  //   DSC:[
  // {name:"Notification & Information Bulletin (School Education)",url:'school'},
  // {name:"Notification & Information Bulletin (Residential Schools)",url:'society'},
  // {name:"Subjects & Syllabus",url:'syllabus'},
  // {name:"MOCK TEST LINKS",url:'MockTest'},
  // {name:"Final Key",url:'renderExams'},
  // {name:"Post Vacancies (School Education)",url:'/SEPostVacancies'},
  // {name:"Post Vacancies (Residential Education)",url:'/REPostVacancies'},
  // {name:"Press Note",url:'pressNote'},
  // {name:"Government Orders (GOs)",url:'gos'},
  // {name:"Frequently Asked Questions",url:'faqs'},
  // {name:"User Manual",url:'manuals'},
  // {name:"Schedule",url:'schedule',clickable: openDocumentModal("Schedule", "schedule")},
  // {name:"Mega DSC General Merit List-2025",url:'/MeritList1'},
  //   ]
  dsc_syllabus_2026: [
    {
      name: "Special Education DSC - 2026",
      url:
        process.env.PUBLIC_URL +
        "/DSC-PDF/Syllabus-2026/Special Education DSC - 2026.pdf",
    },
  ],
};

const DocumentsModal = ({ show, handleClose, title, data, onItemClick }) => {
  const handleItemClick = (item) => {
    if (item.type === "video" || item.type === "link") {
      window.open(item?.url, "_blank");
    } else {
      if (onItemClick) {
        onItemClick(item);
      } else {
        ShowPDF(item.url);
      }
    }
    handleClose();
  };
  const [loading, setLoading] = useState(false);
  const showFinalKeyColumn =
    Array?.isArray(data) && data.some((item) => item?.f_key);

  const showTETAug26FinalKeyCols =
    Array.isArray(data) && data.some((item) => item?.final_url);
  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <>
          {loading && (
            <div className="fp-container">
              <Spinner
                animation="border"
                variant="info"
                className="fp-loader"
              />
            </div>
          )}
        </>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>{title === "APDSC-2025 MOCK TEST LINKS" && "Post"} Name</th>
              {title === "APDSC-2025 Answer Keys" || title === "APTET-2026 Answer Keys" ||
                title === "APTET-2025 Answer Keys" ? (
                <>
                  {" "}
                  <th>Initial Key</th>
                  {/* {showFinalKeyColumn && <th>Final Key</th>} */}
                  {showTETAug26FinalKeyCols && <th>Final Key</th>}
                </>
              ) : (
                <th>Action</th>
              )}
            </tr>
          </thead>
          <tbody>
            {data &&
              data?.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}.</td>
                  <td>{item.name}</td>
                  {title === "APDSC-2025 Answer Keys" ||
                    title === "APTET-2025 Answer Keys" || title === "APTET-2026 Answer Keys" ? (
                    <>
                      <th>
                        {" "}
                        <button
                          type="button"
                          className="btn btn-primary ms-2 p-2 pt-1"
                          disabled={loading}
                          onClick={() => {
                            if (["APTET-2026 Answer Keys"].includes(title)) {
                              handleItemClick(item);
                            } else {
                              downloadPDF(item.c_key, setLoading);
                            }
                          }}
                        >
                          <BsDownload className="me-1" />
                        </button>
                      </th>

                      {showTETAug26FinalKeyCols && (
                        <th>
                          {item?.final_url ? (
                            <button
                              type="button"
                              className="btn btn-primary ms-2 p-2 pt-1"
                              disabled={loading}
                              onClick={() =>
                                ShowPDF(config.url.FILE_VIEW_URL + item.final_url)
                              }
                            >
                              <BsDownload className="me-1" />
                            </button>
                          ) : (
                            "-"
                          )}
                        </th>
                      )}
                      {/* {showFinalKeyColumn && (
                        <th>
                          {item?.f_key ? (
                            <button
                              type="button"
                              className="btn btn-primary ms-2 p-2 pt-1"
                              onClick={() =>
                                downloadPDF(item.f_key, setLoading)
                              }
                            >
                              <BsDownload className="me-1" />
                            </button>
                          ) : (
                            "-"
                          )}
                        </th>
                      )} */}
                    </>
                  ) : (
                    <td>
                      <Button
                        variant="primary"
                        onClick={() => handleItemClick(item)}
                      >
                        Click Here
                      </Button>
                    </td>
                  )}
                </tr>
              ))}
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default DocumentsModal;
